const swagger = {
    invalid_zod_type: '无效的 Zod 类型，请检查路由校验配置。',
    not_supported_zod_type_for_params: '请求参数不支持此 Zod 类型，请检查路由校验配置。',
};
export default Object.freeze(swagger);
